import React from 'react';
import * as LucideIcons from 'lucide-react';

// Logger para errores SVG
const logSvgError = (iconName, error) => {
  console.warn(`🛡️ SVG Protected: Icon "${iconName}" had error:`, error.message);
};

// Componente AppIcon ULTRA-PROTEGIDO
function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    // Lista exhaustiva de iconos verificados
    const verifiedIcons = {
        // Básicos
        'HelpCircle': () => <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth={strokeWidth}/>,
        'Search': () => <circle cx="11" cy="11" r="8" fill="none" stroke={color} strokeWidth={strokeWidth}/>,
        'User': () => <circle cx="12" cy="7" r="4" fill="none" stroke={color} strokeWidth={strokeWidth}/>,
        
        // Estados
        'CheckCircle': () => (
            <g>
                <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M9 12l2 2 4-4" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'X': () => <path d="M18 6L6 18M6 6l12 12" stroke={color} strokeWidth={strokeWidth} fill="none"/>,
        'Clock': () => (
            <g>
                <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M12 6v6l4 2" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'AlertCircle': () => (
            <g>
                <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M12 8v4" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M12 16h.01" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        
        // Interfaz
        'Calendar': () => (
            <g>
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M16 2v4M8 2v4M3 10h18" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'Hash': () => <path d="M4 9h16M4 15h16M9 9v6M15 9v6" stroke={color} strokeWidth={strokeWidth} fill="none"/>,
        'TrendingUp': () => <path d="M7 14l3-3 4 4 5-5" stroke={color} strokeWidth={strokeWidth} fill="none"/>,
        'Sparkles': () => (
            <g>
                <path d="M9 9l2 2M15 9l-2 2" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M12 7v2M12 15v2M7 12h2M15 12h2" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'Database': () => (
            <g>
                <ellipse cx="12" cy="5" rx="9" ry="3" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'Zap': () => <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8" stroke={color} strokeWidth={strokeWidth} fill="none"/>,
        'Shield': () => (
            <g>
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'CreditCard': () => (
            <g>
                <rect x="2" y="4" width="20" height="16" rx="2" ry="2" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M2 8h20" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'ShoppingCart': () => (
            <g>
                <circle cx="9" cy="21" r="1" fill={color}/>
                <circle cx="20" cy="21" r="1" fill={color}/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'MessageCircle': () => (
            <g>
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        
        // Navegación
        'Home': () => (
            <g>
                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M9 22V12h6v10" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'History': () => (
            <g>
                <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M12 6v6l4 2" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M16 2v4M8 2v4M3 10h18" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        
        // Botones
        'RefreshCw': () => <path d="M21 12a9 9 0 1 1-3-6.7L21 3" stroke={color} strokeWidth={strokeWidth} fill="none"/>,
        'Upload': () => (
            <g>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M7 10l5 5 5-5" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M12 15V3" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'Camera': () => (
            <g>
                <rect x="2" y="6" width="20" height="14" rx="2" ry="2" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M16 11.37A2 2 0 1 1 13.63 8 2 2 0 0 1 16 11.37z" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <circle cx="12" cy="13" r="3" fill="none" stroke={color} strokeWidth={strokeWidth}/>
            </g>
        ),
        'Info': () => (
            <g>
                <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M12 16v-4" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M12 8h.01" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'Circle': () => <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth={strokeWidth}/>,
        'AlertTriangle': () => (
            <g>
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M12 9v4" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M12 17h.01" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'Ticket': () => (
            <g>
                <path d="M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7z" stroke={color} strokeWidth={strokeWidth} fill="none"/>
                <path d="M6 7v4M18 7v4" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'Check': () => <path d="M4 12l8 8 12-12" stroke={color} strokeWidth={strokeWidth} fill="none"/>,
        'FileText': () => (
            <g>
                <rect x="3" y="6" width="18" height="12" rx="2" ry="2" fill="none" stroke={color} strokeWidth={strokeWidth}/>
                <path d="M3 10h18M8 2v4M16 2v4" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'Minus': () => <path d="M5 12h14" stroke={color} strokeWidth={strokeWidth} fill="none"/>,
        'Plus': () => (
            <g>
                <path d="M12 5v14M5 12h14" stroke={color} strokeWidth={strokeWidth} fill="none"/>
            </g>
        ),
        'RotateCcw': () => <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 1-6.74 2.74L3 8" stroke={color} strokeWidth={strokeWidth} fill="none"/>,
    };

    try {
        // Si tenemos un icono verificado, usarlo
        if (verifiedIcons[name]) {
            return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    className={className}
                    {...props}
                >
                    {verifiedIcons[name]()}
                </svg>
            );
        }
        
        // Intentar con lucide-react si no está en la lista verificada
        let IconComponent = LucideIcons?.[name];
        if (IconComponent) {
            return (
                <IconComponent
                    size={size}
                    color={color}
                    strokeWidth={strokeWidth}
                    className={className}
                    {...props}
                />
            );
        }
        
        // Fallback último recurso
        console.warn(`🛡️ Icon "${name}" not found, using fallback`);
        return verifiedIcons['HelpCircle']();
        
    } catch (error) {
        // Captura CUALQUIER error de SVG
        logSvgError(name, error);
        return verifiedIcons['HelpCircle']();
    }
}

export default Icon;